import { AvatarCacheEntry } from '../types/CacheEntries';

export const DEFAULT_CACHE_ENTRY: AvatarCacheEntry = {
  uri: null,
  source: null,
};

export const FIRST_TRY_DELAY = 200;
export const SECOND_TRY_DELAY = 1000;
export const LAST_TRY_DELAY = 4000;
